import type { ReactNode } from 'react';
import styles from './FeelingChip.module.css';

type FeelingChipProps = {
  children: ReactNode;
  variant: 'before' | 'after';
};

export default function FeelingChip({ children, variant }: FeelingChipProps) {
  return (
    <span className={`${styles.chip} ${variant === 'before' ? styles.before : styles.after}`}>
      {children}
    </span>
  );
}
